import { useQuery } from "@tanstack/react-query";
import { __Dependency_Not_Paginate } from "request/configuration/__Dependency";

// Hook para obtener dependencias sin pagination
export const useDependenciesNotPaginate = (token, enabled = true) => {
  return useQuery({
    queryKey: ["dependenciesNotPaginate"],
    queryFn: async () => {
      const res = await __Dependency_Not_Paginate(token);
      
      if (res.data.status?.code === 403) {
        throw new Error(res?.data?.status?.message);
      }
      
      // Mapear los datos al formato esperado
      return res?.data?.status?.data?.map((item) => ({
        value: item?.id,
        label: item?.dependency,
      })) || [];
    },
    enabled: enabled && !!token,
    staleTime: 10 * 60 * 1000, // 10 minutos (dependencias cambian menos frecuentemente)
    gcTime: 15 * 60 * 1000, // 15 minutos
    refetchOnWindowFocus: false,
    retry: 2,
    retryDelay: 1000
  });
};
